// src/routes/AppRoutes.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ClientLayout from "../components/layout/ClientLayout";
import LoginPage from "../pages/auth/LoginPage";
import RegisterPage from "../pages/auth/RegisterPage";
//import DashboardPage from "../pages/dashboard/DashboardPage";

import WalletOverviewPage from "../pages/wallet/WalletOverviewPage";
import TransferPage from "../pages/wallet/TransferPage";
import WithdrawPage from "../pages/wallet/WithdrawPage";
import HistoryPage from "../pages/wallet/HistoryPage";

import ProfilePage from "../pages/profile/ProfilePage";
import ChangePasswordPage from "../pages/profile/ChangePasswordPage";

import ReferOverviewPage from "../pages/refer/ReferOverviewPage";

import { useAuth } from "../hooks/useAuth";
import ContactPage from "../pages/contact/ContactPage";
import HomePage from "../pages/home/HomePage";
import ReviewPage from "../pages/review/ReviewPage";
import MyReviewsPage from "../pages/review/MyReviewsPage";


function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Dashboard */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <ClientLayout>
                <HomePage />
              </ClientLayout>
            </PrivateRoute>
          }
        />

        {/* Wallet */}
        <Route
          path="/wallet"
          element={
            <PrivateRoute>
              <ClientLayout>
                <WalletOverviewPage />
              </ClientLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/wallet/transfer"
          element={
            <PrivateRoute>
              <ClientLayout>
                <TransferPage />
              </ClientLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/wallet/withdraw"
          element={
            <PrivateRoute>
              <ClientLayout>
                <WithdrawPage />
              </ClientLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/wallet/history"
          element={
            <PrivateRoute>
              <ClientLayout>
                <HistoryPage />
              </ClientLayout>
            </PrivateRoute>
          }
        />

        {/* Profile */}
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ClientLayout>
                <ProfilePage />
              </ClientLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/profile/password"
          element={
            <PrivateRoute>
              <ClientLayout>
                <ChangePasswordPage />
              </ClientLayout>
            </PrivateRoute>
          }
        />

        {/* Refer */}
        <Route
          path="/refer"
          element={
            <PrivateRoute>
              <ClientLayout>
                <ReferOverviewPage />
              </ClientLayout>
            </PrivateRoute>
          }
        />

        <Route
        path="/contact"
        element={
          <PrivateRoute>
            <ClientLayout>
              <ContactPage />
            </ClientLayout>
          </PrivateRoute>
        }
      />
      <Route 
      path="/review/:category" 
      element={
        <PrivateRoute>
            <ClientLayout>
              <ReviewPage />
            </ClientLayout>
          </PrivateRoute>
    
        } 
      />
        <Route path="/my-reviews" element={
          <PrivateRoute>
            <ClientLayout>
              <MyReviewsPage />
            </ClientLayout>
          </PrivateRoute>
          
          } />

      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
